import client from '../axios';
import { DELETE_MEMBER, DELETE_MEMBER_TEACHER, GET_MEMBER, GET_MEMBER_BRANCH, GET_MEMBER_DETAIL, GET_MEMBER_NOTEACHER, GET_MEMBER_SCHOOL, GET_MEMBER_TEACHER, PUT_MEMBER, PUT_MEMBER_CURRICULUM, PUT_MEMBER_EXCEPTION, PUT_MEMBER_REGRESS, PUT_MEMBER_TEACHER, PUT_MEMBER_TRANSFER, PUT_MEMBER_EXCEPTION_BOOK, POST_MEMBER_TRANSFER, PUT_SCHOOL_MEMBER_CLASS_TIME, POST_MEMBER_HANDTAKEOVER, POST_EXCEL_UPLOAD_MEMBER_EXCEPTION } from './endpoint';

// 회원 상세
export const getMemberAPI = (idx) => {
  console.log(idx);
  return client.get(GET_MEMBER_DETAIL.replace(':member_idx', idx));
};

//회원 수정
export const putMemberAPI = (data) => {
  return client.put(PUT_MEMBER, data);
};

// 회원 삭제
export const deleteMemberAPI = (idx) => {
  return client.delete(DELETE_MEMBER.replace(':member_idx', idx));
};

//회원 이동신청
export const postMemberTransferAPI = (data) => {
  return client.post(POST_MEMBER_TRANSFER, data);
};

//회원 이동신청
export const putMemberTransferAPI = (array) => {
  console.log(array);
  return client.put(PUT_MEMBER_TRANSFER, array);
};

//회원 인수 승인/반려
export const postMemberHandTakeOverAPI = (idx, params) => {
  console.log(params)
  return client.post(POST_MEMBER_HANDTAKEOVER.replace(':apply_idx', idx), null, { params });
};

// 회원 교육과정 수정
export const putMemberCurriculumAPI = (data) => {
  return client.put(PUT_MEMBER_CURRICULUM, data);
};

// 휴회/재입회 신청
export const putMemberRegerssAPI = (data) => {
  return client.put(PUT_MEMBER_REGRESS, data);
};

// 다수 회원 수정
export const putMemberExceptionAPI = (data) => {
  return client.put(PUT_MEMBER_EXCEPTION, data);
};

//전체 회원 목록
export const getMemberListAPI = (data) => {
  return client.get(GET_MEMBER, data);
};

// 지사 회원 목록
export const getMemberBranchListAPI = (idx) => {
  return client.get(GET_MEMBER_BRANCH.replace(':branch_idx', idx));
};

// 교육원 회원 목록
export const getMemberSchoolListAPI = (params) => {
  return client.get(GET_MEMBER_SCHOOL.replace(':school_idx', params.school_idx), { params });
};

// 교육원 강사 배정되지 않은 회원 목록
export const getMemberNoTeacherListAPI = (idx) => {
  return client.get(GET_MEMBER_NOTEACHER.replace(':school_idx', idx));
};

// 강사 회원 목록
export const getMemberTeacherListAPI = (idx) => {
  return client.get(GET_MEMBER_TEACHER.replace(':teacher_idx', idx));
};

// 강사 회원 배정
export const putMemberTeacherAPI = (idx, data) => {
  console.log(idx.tostring, data);
  //data->int array
  return client.put(PUT_MEMBER_TEACHER.replace(':teacher_idx', idx), data);
};
// 강사 회원 배정
export const putExceptionBookAPI = (data) => {
  console.log(data);
  //data->int array
  return client.put(PUT_MEMBER_EXCEPTION_BOOK, data);
};

// 강사 회원 삭제
export const deleteMemberTeacherAPI = (data) => {
  return client.put(DELETE_MEMBER_TEACHER, data);
};

// 멤버 수업시간 수정
export const putMemberClassTimeAPI = (data) => {
  return client.put(PUT_SCHOOL_MEMBER_CLASS_TIME, data);
};

// 예외교습 엑셀 업로드
export const postMemberExceptionExcelUploadAPI = (data) => {
  return client.post(POST_EXCEL_UPLOAD_MEMBER_EXCEPTION, data, { headers: { 'Content-Type': 'multipart/form-data' } });
}

